export const boldText = "aEc";
export const italicText = "bEc";
export const underlineText = "cEc";
export const bulletsText = "dEc";
export const numberingText = "eEc";
export const outdentText = "fEc";
export const indentText = "gEc";
export const blockQuoteText = "hEc";
export const alignLeftText = "iEc";
export const alignRightText = "jEc";
export const alignCenterText = "kEc";
export const superscriptText = "lEc";
export const subscriptText = "mEc";
export const strikethroughText = "nEc";
export const dirLtrText = "oEc";
export const dirRtlText = "pEc";
export const removeFormatText = "qEc";
export const undoText = "rEc";
export const redoText = "sEc";
export const formatPainterText = "tEc";
export const changeCaseText = "uEc";
export const uppercaseText = "vEc";
export const lowercaseText = "wEc";
export const capitalizeEachWordText = "xEc";
export const sentenceCaseText = "yEc";
export const fontColorText = "zEc";
export const moreColorsText = "AEc";
export const customColorsText = "BEc";
export const noColorText = "CEc";
export const highlightColorText = "DEc";
export const cutText = "EEc";
export const copyControlText = "FEc";
export const pasteText = "GEc";
export const fontNameText = "HEc";
export const fontSizeText = "IEc";
export default {boldText,italicText,underlineText,bulletsText,numberingText,outdentText,indentText,blockQuoteText,alignLeftText,alignRightText,alignCenterText,superscriptText,subscriptText,strikethroughText,dirLtrText,dirRtlText,removeFormatText,undoText,redoText,formatPainterText,changeCaseText,uppercaseText,lowercaseText,capitalizeEachWordText,sentenceCaseText,fontColorText,moreColorsText,customColorsText,noColorText,highlightColorText,cutText,copyControlText,pasteText,fontNameText,fontSizeText};